import { Button } from '@components/button';
import { ButtonGroup } from '@components/button-group';
import { LabelTextGroup } from '@components/label-text-group';
import { Spinner } from '@components/loading-spinner';
import { Sidebar } from '@components/sidebar';
import { hideSidebar } from '@components/sidebar';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyTravellerAction } from 'api/traveller-actions/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';

import { SidebarProps, TravellerActionHeader } from '../common';

const ACTION_TYPE = ACTION_TYPES.placeholder;

export const SidebarContent = ({ shortId }: SidebarProps) => {
  const { t } = useScopedTranslate(sidebarLocale);
  const travellerActionQuery = useJourneyTravellerAction(shortId);

  if (travellerActionQuery.isLoading) {
    return <Spinner />;
  }

  if (!shortId || !travellerActionQuery.data) {
    return <div>{t('dataNotFound')}</div>;
  }

  const action = travellerActionQuery.data;

  return (
    <Sidebar>
      <TravellerActionHeader actionType={ACTION_TYPE} />
      <Sidebar.Content>
        <Stack space={4}>
          <LabelTextGroup label={t('description')} text={action.description} />
        </Stack>
      </Sidebar.Content>
      <Sidebar.Footer>
        <ButtonGroup align="right">
          <Button variant="secondary" text={t('core.close')} onClick={hideSidebar} />
        </ButtonGroup>
      </Sidebar.Footer>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    description: 'Description',
    dataNotFound: 'Data not found',
  },
};
